<template>
  <ValidationProvider v-slot="{ errors }" :rules="'required'">
    <v-text-field
      aria-label="Text"
      v-model="answer"
      :error-messages="showValidationErrors ? errors : ''"
      @input="handleChange"
      label=""
      class="mt-0"
      placeholder=""
      persistent-hint
    />
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { first } from "lodash";

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    showValidationErrors: Boolean
  },
  components: {
    ValidationProvider
  },
  created() {
    if (this.question.answerData) {
      this.answer = first(this.question.answerData.answers);
    }
  },
  data() {
    return {
      answer: null
    };
  },
  methods: {
    handleChange(value) {
      this.answers = [value];
      this.$emit("onChange", {
        answers: [value],
        question: {
          type: "booking-application-questions",
          id: this.question.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
